// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"bfd5c8dc","144":"53149859","222":"40a1c692","228":"7ac3a6a5","297":"33febaf8","688":"b6151b6d","712":"49115fa4"}[chunkId] + ".chunk.css";
};